// extracted by mini-css-extract-plugin
export default {"moreButtonMobile":"_3O3Zd"};